import { render, staticRenderFns } from "./view-profile.vue?vue&type=template&id=ac4a3d16&"
import script from "./view-profile.vue?vue&type=script&lang=js&"
export * from "./view-profile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports